var defaultQuickRanges = ['last7Days', 'last14Days', 'last30Days', 'thisMonth', 'lastMonth', 'ytd'];

export { defaultQuickRanges };
